import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_APPROVE_ACCOUNT_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_APPROVE_ACCOUNT_API_ID';

const approveAccount = createApiCall(
  FETCH_INVESTCORE_APPROVE_ACCOUNT_API_ID,
  ({ id, payload }) => ({
    endpoint: `/api/admin/users/${id}/approve`,
    method: 'PATCH',
    body: payload,
    notify: true,
    isReload: true,
  })
);

export default approveAccount;
